<template>
  <div >
      <div class="customHeight">

    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="heading">Shipping Instruction</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSaveUser">
          <div class="SpinnerAdj">
            <callingApiCenter
              type="bar"
              :paths="[
                '/api/w/DOs/WebSearchBooking',
                '/api/w/users',
                '/api/w/DOs/WebAssignBooking',
              ]"
            >
            </callingApiCenter>
          </div>
          <span class="ErrorMessage1" v-if="errmsg != ''">{{ errmsg }}</span>
          <div v-if="getSearchBox == true">
            <div class="inputBoxDouble">
              <div class="inputBoxSpace">
                <template v-if="deliverytypeselect">
                  <auto-complete-select
                           :options="dispDOTypeList"
                           label="Del Type"
                           :value="dataForm.deliveryType"
                           :on-item-changed="handleDeliveryType"
                        >
               </auto-complete-select>
              </template>
              <template v-else>
               <md-field>
                  <label>Del Type</label>
                  <md-input v-model="dataForm.deliveryType" disabled />
                </md-field>
              </template>
              </div>
              <div class="inputBoxSpace">
                <md-field>
                  <label>Sales Office</label>
                  <md-input v-model="dataForm.salesOffice" disabled />
                </md-field>
              </div>
            </div>

            <div class="inputBoxDouble">
              <div class="inputBoxSpace">
                <!--
                <md-field>
                  <label>Ctnr Type</label>
                -->
                  <!-- <md-input v-model="dataForm.ctnrType" disabled /> -->
                  <!--
                  <md-input v-model="dataForm.ctnrType"/>
                </md-field>
              -->
                 <auto-complete-master-data-select
                              group="CCR_CNTRTYPE"
                              label="Ctnr Type"
                              :init-value="dataForm.ctnrType"
                              :on-item-changed="handleCtnrTypeChanged"
                           >
                  </auto-complete-master-data-select>

              </div>

              <div class="inputBoxSpace">
                <md-field>
                  <label>Grade</label>
                  <md-input v-model="dataForm.grade" disabled />
                </md-field>
              </div>
            </div>

            <!-- <div ref = "refCarrier" class="searchPanel inputBoxDouble">
              <div class="inputBoxWide">
                <auto-complete-master-data-select
                  group="GST_CARRIER"
                  label="Ocean Carrier"
                  :init-value="dataForm.scac"
                  :on-item-changed="handleCarrierChanged"
                >
                </auto-complete-master-data-select>
              </div>
            </div> -->

            <div class="inputBoxDouble">
              <div class="inputBoxWide">
                <!--
                <md-field>
                  <label>Carrier</label>
                  <md-input v-model="dataForm.scac" />
                </md-field>
              -->
                <auto-complete-master-data-select
                              group="STC_CARRIER"
                              label="Carrier"
                              :init-value="dataForm.scac"
                              :on-item-changed="handleCarrierChanged"
                           >
                </auto-complete-master-data-select>

              </div>
            </div>

            <div class="inputBoxDouble">
              <div class="inputBoxSpace">
                <md-field>
                  <label>Booking#</label>
                  <md-input v-model="dataForm.bookObl" />
                </md-field>
              </div>

              <div class="inputBoxSpace">
                <md-field>
                  <label>IBD#</label>
                  <md-input v-model="dataForm.customerPO" />
                </md-field>
              </div>
            </div>


            <div class="inputBoxDouble">
              <div class="inputBoxSpace">
                <!-- <DatePickerBackdate v-model="dataForm.cutLFD.startDate"
                
                > -->
                <datepicker v-model="dataForm.cutLFD.startDate">
                  <label>Cut off Date</label>
                <!-- </DatePickerBackdate> -->
                </datepicker>
              </div>


              <div class="inputBoxSpace">
                <!-- <DatePickerBackdate v-model="dataForm.cutLFD.endDate"
                
                > -->
                <datepicker v-model="dataForm.cutLFD.endDate">
                  <label>To</label>
                <!-- </DatePickerBackdate> -->
                </datepicker>
              </div>
            </div>
            <div class= "inputBoxMessage">
              <b-notification class = "notifySize"
                  type="is-danger"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
              </b-notification>

            </div>


            <div class="inputBoxDouble">
              <div class="inputBtnSpace">
                <md-button
                  class="md-raised custButtonWide"
                  @click="searchBooking(dataForm)"
                  ><span class="icons-center material-icons">cancel</span
                  >Search</md-button
                >
              </div>

              <div class="inputBtnSpace">
                <md-button
                  class="md-raised custButtonWide"
                  @click="clearAction"
                  ><span class="icons-center material-icons">cancel</span
                  >Clear</md-button
                >
              </div>
            </div>
          </div>

          <div v-if="getBookingTable"
          class = "fixBlur">
            <md-table
              v-model="items"
              md-sort="name"
              md-sort-order="asc"
              md-card
              @md-selected="onSelect"
              :class="getTableHeight()"
            >
              <md-table-toolbar>
                <h1 v-if="items.length === 0" class="md-title">
                  No booking found!.
                </h1>
                <h1 v-else class="md-title">
                  {{ items.length }} Available Bookings
                </h1>

                <h1 v-if="lenError != null" class="ErrorMessage md-title">
                  {{ lenError }}
                </h1>
              </md-table-toolbar>

              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                md-selectable="single"
              >

                <md-table-cell md-label="Doc Due" md-sort-by="docCut">
                  <h1 v-if="docCutDue >= item.docCut">🛑</h1>
                </md-table-cell>

                <md-table-cell md-label="Status" md-sort-by="deliveryStatus">{{
                  item.deliveryStatus
                }}</md-table-cell>
                <md-table-cell
                  md-label="Del Order"
                  md-sort-by="deliveryOrder"
                  >{{ item.deliveryOrder }}</md-table-cell
                >
                <md-table-cell md-label="Cust PO" md-sort-by="customerPO">{{
                  item.customerPO
                }}</md-table-cell>
                <md-table-cell md-label="Doc Due" md-sort-by="docCut">{{
                  item.docCut | date
                }}</md-table-cell>

                <md-table-cell md-label="Cut Off" md-sort-by="cutLFD">{{
                  item.cutLFD | date
                }}</md-table-cell>
                <md-table-cell md-label="Booking" md-sort-by="bookObl">{{
                  item.bookObl
                }}</md-table-cell>
                <md-table-cell md-label="Count" md-sort-by="ctnrCount">{{
                  item.ctnrCount
                }}</md-table-cell>
                <md-table-cell md-label="Assign" md-sort-by="ctnrAssign">{{
                  item.ctnrAssign == null ? "0" : item.ctnrAssign
                }}</md-table-cell>
                <md-table-cell md-label="Ctype" md-sort-by="ctnrType">{{
                  item.ctnrType
                }}</md-table-cell>
                <md-table-cell md-label="Pickup Loc" md-sort-by="pickupLoc">{{
                  item.pickupLoc
                }}</md-table-cell>
                <md-table-cell md-label="Del To" md-sort-by="deliveryTo">{{
                  item.deliveryTo
                }}</md-table-cell>
                <md-table-cell md-label="Pickup Tml" md-sort-by="ctnrPickup">{{
                  item.ctnrPickup
                }}</md-table-cell>
                <md-table-cell
                  md-label="Dropoff Tml"
                  md-sort-by="ctnrDropOff"
                  >{{ item.ctnrDropOff }}</md-table-cell
                >
                <md-table-cell md-label="SCAC" md-sort-by="scac">{{
                  item.scac
                }}</md-table-cell>
                <md-table-cell md-label="Vessel" md-sort-by="vesselName">{{
                  item.vesselName
                }}</md-table-cell>
                <md-table-cell md-label="Voyage" md-sort-by="voyage">{{
                  item.voyage
                }}</md-table-cell>
                <md-table-cell md-label="Grade" md-sort-by="arktx">{{
                  item.arktx
                }}</md-table-cell>
                <md-table-cell md-label="BK Remark" md-sort-by="remark_bsi">{{
                  item.remark_bsi
                }}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>

          <div class="alwaysShow">
            <div>
              <md-dialog-actions>
                <md-button class="md-raised custButton" @click="cancalAction"
                  ><span class="icons-center material-icons">cancel</span
                  >Back</md-button
                >
                <md-button
                  type="submit"
                  class="md-raised custButton"
                  :disabled="lenError != null || selected == null"
                  ><span class="icons-center material-icons">create</span
                  >Assign</md-button
                >
              </md-dialog-actions>
            </div>
          </div>
        </form>
      </md-dialog-content>
    </md-dialog>
     </div>
  </div>
</template>

<style scoped>
form {
  min-width: 640px;
  max-width: 1200px;
  margin: 24px;
}

.tableFormat {
  height: 400px;
}

.tableMinFormat {
  height: 100px;
}

form .md-field {
  margin: 0 0;
}

.md-dialog {
    max-height: 90% !important;
}

.inputBoxSpace {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxWide {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 425px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBtnSpace {
  font-size: 18px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxDouble {
  width: 450px;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputBoxMessage {
  width: 425px;
  margin: auto;
}



.inputBoxInbound {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 12px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxInbound:hover {
  border: 2px solid #448aff;
  border-radius: 5px;
  color: #29303b;
  font-size: 12px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
  background-color: #e0eff7;
}

.alwaysShow {
  position: fixed;
  right: 60px;
  top: 30px;
}

.ErrorMessage {
  color: #f14668 !important;
}
.ErrorMessage1 {
  color: #f14668 !important;
  margin-bottom: 5px;
}

.redButton {
  background-color: #c50000;
  z-index: 4;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}

.custButton {
  margin: 10px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  font-size: 0.9rem;
}

.custButtonWide {
  width: 200px;
  height: 40px;
  line-height: 40px;
  font-size: 0.9rem;
}

.SpinnerAdj {
  margin-left: 90px;
}

.heading {
  padding-top: 20px;
  margin-bottom: 0;
  color: #555555;
  width: 92%;
  line-height: 3;
  font-size: 32px;
  font-family: Roboto Slab;
  margin-left: 44px;
}

.layout {
  padding-top: 7px;
  padding-bottom: 7px;
  width: 92%;
  line-height: 1.5;
  color: #555555;

  font-family: Roboto Slab;
  margin: auto;
}

.md-table-row {
  background: white;
}

.md-table.md-theme-default .md-table-row.md-selected-single {
  background: #726a95;
}
</style>
<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import dateFormat from "../utils/dateFormat";
import { minLength, required, maxLength } from "vuelidate/lib/validators";
import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
import DatePickerBackdate from "./DatePickerBackDate.vue";
import callingApiCenter from "../components/CallingApiCenter.vue";
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import load from "../vuex/load";
import moment from 'moment';

const getInitialdataForm = () => ({
  salesOffice: "LGB",
  //deliveryStatus: "Not Assign and Partil Assign",
  //deliveryType: "YY",
  deliveryType: null,
  ctnrType: null,
  //arktx: null,
  bookObl: null,
  scac: null,
  customerPO: null,
  cutLFD: {
    startDate: null,
    endDate: null,
  },
  grade: null
});

export default {
  components: { AutocompleteCcicLocationSelect, callingApiCenter,DatePickerBackdate },
  mixins: [validationMixin],
  props: {
    mode: String,
    stage: String,
    action: Function,
  },
  data: () => ({
    showDialog: false,
    dataForm: getInitialdataForm(),
    items: [],
    loadcarrier: null,
    loadctnrType: null,
    selected: null,
    getBookingTable: false,
    getSearchBox: true,
    lenError: null,
    loads: [],
    dispDOTypeList: [],
    notifyActive: false,
    notifyMessage: 'Cut off Start Date is required!',
    trimOption: [
      "bookObl",
      "customerPO"
    ],
    deliverytypeselect: false,
    load_grade: null,
    docCutDue: dateFormat.getLocalDate(moment(moment().add(2,'days').startOf('d').toDate())),
    load_emptypulledbooking: null,
    errmsg: null,
  }),
  computed: {
    ...mapGetters([
      "getMasterDataByGroup",
      "getMasterDataName",
      "getUserProfile",
    ]),
  },

  validations: {
    dataForm: {
      salesOffice: {},
    },
  },

  methods: {
    trimTool(ent) {
      return ent == null ? null : ent.trim()
    },

    onSelect(item) {
      if (item == null) {
        this.lenError = null;
      } else {
        this.lenError = null;
        const count = Number(item.ctnrCount);
        const assigned = item.ctnrAssign == null ? 0 : Number(item.ctnrAssign);
        if (this.loads.length > count - assigned) {
          this.lenError = `Total selected container count exceed to this IBD by ${
            this.loads.length - (count - assigned)
          }!`;
        }
      }
      this.selected = item;
    },

    async openDialog(loads) {
      console.log("load[0] carrier: " + loads[0].carrier);
      this.load_grade = loads[0].grade;
      this.load_emptypulledbooking = loads[0].emptyPulledBooking;
      this.$store.commit("clearApiError");
      this.$v.dataForm.$reset();
      this.dataForm = getInitialdataForm();
      this.loads = loads;
      this.getBookingTable = false;
      this.getSearchBox = true;
      this.selected = null;
      this.notifyActive = false;
      if (this.mode && this.mode != "")
         this.dataForm.deliveryType = this.mode;
      this.dataForm.ctnrType = this.getFullCtnrTypeFromCode(loads[0].ctnrType);
      //this.dataForm.arktx = loads[0].grade;
      this.dataForm.grade = loads[0].grade;
      this.loadcarrier = loads[0].carrier;
      if (loads[0].carrier && loads[0].carrier != "")
         this.dataForm.scac = this.getFullCarrierFromCode(loads[0].carrier);
      this.loadctnrType = this.dataForm.ctnrType;
      this.dataForm.cutLFD.startDate = moment().toDate();
      this.dataForm.cutLFD.endDate = moment().add(3,'months').endOf('d').toDate();
      this.dispDOTypeList.push("YY");
      this.dispDOTypeList.push("YE");
      if (this.mode == "YY") this.deliverytypeselect = true;
      console.log(loads);
      this.showDialog = true;
    },

    async searchBooking(item) {
      if (this.load_grade == null || this.load_grade == "") {
         alert("Searching grade/grade in load has no info, please check!!");
      } 

      this.notifyActive = false;
      if (this.getContentFromBrace(item.scac) != this.loadcarrier) 
         alert("The search carrier " + this.getContentFromBrace(item.scac) + " does not match with container carrier " + this.loadcarrier + ", continue!!");
      console.log("searchbooking scac: " + item.scac);
      item.scac = this.getContentFromBrace(item.scac);
      item.ctnrType = this.getContentFromBrace(item.ctnrType);
      const request = JSON.parse(JSON.stringify(item));
      if (request.cutLFD.startDate == null) {
        this.notifyActive = true;
        return
      }

      request.cutLFD.startDate = dateFormat.getLocalDateOnly(request.cutLFD.startDate);
      if (request.cutLFD.endDate == null || request.cutLFD.endDate == "")
      {
          request.cutLFD.endDate = request.cutLFD.startDate;
      }
      else
      {
          request.cutLFD.endDate = dateFormat.getLocalDateOnly(request.cutLFD.endDate);
      }

      request.arktx = this.dataForm.grade;
      request.scac = this.dataForm.scac;

      for (const el of this.trimOption) {
        request[el] = this.trimTool(request[el]);
      }

      var notmatch = false;
      this.errmsg = "";
      //api.post("/api/w/DOs/WebSearchBooking", request).then((res) => {
      newAPIPost("/api/w/DOs/WebSearchBooking", request).then((res) => {
        this.items = res;
        if (this.items && this.items.length > 0) {
            console.log("items from booking search: " + JSON.stringify(res));
            console.log("grade from search: " + this.items[0].arktx + " grade from load: " + this.load_grade);
            var showonlywarning = false;
            if (this.items[0].arktx != this.load_grade) {
              console.log(`bk check grade: ${this.getMasterDataName('BK_CHECK_GRADE',this.load_grade)}`);
              if (this.getMasterDataName('BK_CHECK_GRADE',this.load_grade) == this.items[0].arktx)
              {
                  showonlywarning = true;
              } 
               //alert("Searching grade does not match with grade in load, please check!!");
              //  this.$buefy.notification.open({
              //       duration: 5000,
              //       message: `Searching grade ${this.items[0].arktx} does not match with grade in load ${this.load_grade}, please check!!`,
              //       position: 'is-top-right',
              //       type: 'is-danger',
              //       hasIcon: true
              //   })
              if (!showonlywarning)
              {
                notmatch = true;
                this.errmsg = `The searching booking grade ${this.items[0].arktx} does not match with grade in load ${this.load_grade}, please correct to process!!`;
              } else {
                alert(`You may continue with the searching booking grade ${this.items[0].arktx} does not match with grade in load ${this.load_grade}!!`);
              }
            }
        }
        if (!notmatch)
        {
          this.getBookingTable = true;
          this.getSearchBox = false;
        }
      });
    },


    clearAction() {
      this.dataForm.cutLFD.startDate = moment().toDate();
      this.dataForm.bookObl = null;
      //this.dataForm.customerPO = null;
      //this.dataForm.scac = this.loadcarrier;
      this.handleCarrierChanged(this.loadcarrier);
      this.dataForm.ctnrType = this.loadctnrType;
      //this.$refs.refCarrier.querySelector('button.md-clear').click();
      
    },

    getValidationClass(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
      return {};
    },

     
    getTableHeight() {
       
       if (this.items.length === 0)
       {
          return {
          "tableMinFormat": true,
        };
       }
       else
       {
         return {
          "tableFormat": true,
        };
       }
        return {};
      },

   

    cancalAction() {
      this.lenError = null;
      if (this.getBookingTable == true) {
        this.$store.commit("clearApiError");
        this.getBookingTable = false;
        this.getSearchBox = true;
        this.selected = null;
      } else {
        this.$store.commit("clearApiError");
        this.showDialog = false;
      }
    },

    getFullCarrierFromCode(code) {
       var carriername = "";
       carriername = this.getMasterDataName("STC_CARRIER",code);
       if (carriername != "")
          return carriername + "(" + code + ")"; 
       else
          return code;   
    },

    getFullCtnrTypeFromCode(code) {
       var ctnrtypename = "";
       ctnrtypename = this.getMasterDataName("CCR_CNTRTYPE",code);
       if (ctnrtypename && ctnrtypename != "" && ctnrtypename != "undefined")
          return ctnrtypename + "(" + code + ")"; 
       else
          return code;   
    },

    async doSaveUser() {
      this.$v.dataForm.$touch();

      // const time = moment().format('HH:mm:ss');
      // const date = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + time;
      //var assignbooking = false;
      // if (this.load_emptypulledbooking != null && this.load_emptypulledbooking != '')
      // {
      //    if (this.load_emptypulledbooking != this.selected.bookObl)
      //    {
      //       this.$buefy.dialog.confirm({
      //               title: 'Mis-Match Booking', 
      //               message: `Empty pulled booking: ${this.load_emptypulledbooking}` + '; ' + `Going assign booking: ${this.selected.bookObl}` + '; Are you sure you want to Assign the booking?',
      //               confirmText: 'Assign',
      //               type: 'is-danger',
      //               hasIcon: true,
      //               onConfirm: async () => {
      //                 //assignbooking = true;
      //                 console.log(`confirm assignbooking`);
      //                 this.confirmedAssignBK();
      //               }
      //       })
      //     } else { // if empty pull = selected bk
      //       this.confirmedAssignBK();
      //     }   
      // } else {
      //   this.confirmedAssignBK();
      // }

      this.confirmedAssignBK();

      // console.log(`assignbooking: ${assignbooking}`);

      // if (assignbooking)
      // {
      //   if ( this.docCutDue >= this.selected.docCut)
      //   {
      //     if (confirm("Document Cutoff is about due. Please make sure Load can be confirmed before Doc-Cut Date!")) {
      //       const request = {
      //         salesOffice: this.dataForm.salesOffice,
      //         deliveryOrder: this.selected.deliveryOrder,
      //         assignDate: date,
      //         loads: this.loads.map((it) => ({
      //           user: it.user,
      //           seqNo: it.seqNo,
      //         })),
      //       };
      //       console.log("assign booking req: " + JSON.stringify(request));
      //       var loadRef = "";
      //       if (!this.stage)
      //           loadRef = this.loads.map(it => it.seqNo).toString();
      //       else
      //           loadRef = this.loads.map(it => it.vueKey).toString();    
      //       api.post("/api/w/DOs/WebAssignBooking", request).then((res) => {
      //         this.showDialog = false;
      //         this.$store.commit("clearApiError");
      //         this.action(this.selected.deliveryOrder, this.selected.bookObl, 'ASN', loadRef,
      //                     this.selected.ctnrPickup, this.selected.ctnrDropOff, this.selected.scac,
      //                     this.selected.ctnrType, this.selected.arktx);
      //       });
      //     }
      //   }
      //   else{
      //     const request = {
      //       salesOffice: this.dataForm.salesOffice,
      //       deliveryOrder: this.selected.deliveryOrder,
      //       assignDate: date,
      //       loads: this.loads.map((it) => ({
      //         user: it.user,
      //         seqNo: it.seqNo,
      //       })),
      //     };
      //     console.log("assign booking req: " + JSON.stringify(request));
      //     var loadRef = "";
      //     if (!this.stage)
      //         loadRef = this.loads.map(it => it.seqNo).toString();
      //     else
      //         loadRef = this.loads.map(it => it.vueKey).toString();    
      //     api.post("/api/w/DOs/WebAssignBooking", request).then((res) => {
      //       this.showDialog = false;
      //       this.$store.commit("clearApiError");
      //       this.action(this.selected.deliveryOrder, this.selected.bookObl, 'ASN', loadRef,
      //                   this.selected.ctnrPickup, this.selected.ctnrDropOff, this.selected.scac,
      //                   this.selected.ctnrType, this.selected.arktx);
      //     });
      //   }
      // }
    },

    confirmedAssignBK()
    {
      const time = moment().format('HH:mm:ss');
      const date = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + time;
      if ( this.docCutDue >= this.selected.docCut)
        {
          if (confirm("Document Cutoff is about due. Please make sure Load can be confirmed before Doc-Cut Date!")) {
            const request = {
              salesOffice: this.dataForm.salesOffice,
              deliveryOrder: this.selected.deliveryOrder,
              assignDate: date,
              loads: this.loads.map((it) => ({
                user: it.user,
                seqNo: it.seqNo,
              })),
            };
            console.log("assign booking req: " + JSON.stringify(request));
            var loadRef = "";
            if (!this.stage)
                loadRef = this.loads.map(it => it.seqNo).toString();
            else
                loadRef = this.loads.map(it => it.vueKey).toString();    
            //api.post("/api/w/DOs/WebAssignBooking", request).then((res) => {
            newAPIPost("/api/w/DOs/WebAssignBooking", request).then((res) => {
              this.showDialog = false;
              this.$store.commit("clearApiError");
              this.action(this.selected.deliveryOrder, this.selected.bookObl, 'ASN', loadRef,
                          this.selected.ctnrPickup, this.selected.ctnrDropOff, this.selected.scac,
                          this.selected.ctnrType, this.selected.arktx);
            });
          }
        }
        else{
          const request = {
            salesOffice: this.dataForm.salesOffice,
            deliveryOrder: this.selected.deliveryOrder,
            assignDate: date,
            loads: this.loads.map((it) => ({
              user: it.user,
              seqNo: it.seqNo,
            })),
          };
          console.log("assign booking req: " + JSON.stringify(request));
          var loadRef = "";
          if (!this.stage)
              loadRef = this.loads.map(it => it.seqNo).toString();
          else
              loadRef = this.loads.map(it => it.vueKey).toString();    
          //api.post("/api/w/DOs/WebAssignBooking", request).then((res) => {
          newAPIPost("/api/w/DOs/WebAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(this.selected.deliveryOrder, this.selected.bookObl, 'ASN', loadRef,
                        this.selected.ctnrPickup, this.selected.ctnrDropOff, this.selected.scac,
                        this.selected.ctnrType, this.selected.arktx);
          });
        }

    },

    handleCarrierChanged(id) {
      this.dataForm.scac = this.getFullCarrierFromCode(id);
    },

    handleCtnrTypeChanged(id) {
      this.dataForm.ctnrType = this.getFullCtnrTypeFromCode(id);
    },

    getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },
    handleDeliveryType(id) {
        console.log("handleDeliverType: " + id);
        //return (id) => {
          //console.log("handle delivery type: " + id);
          this.dataForm.deliveryType = id;
        //}
    },  

  },
};
</script>
